export default "__VITE_ASSET__D2Bm5DE8__"